import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state, { IMapLayerState } from './state'
import { Module } from 'vuex/types'
import { IRootState } from '@/store'

const mapLayerModule: Module<IMapLayerState, IRootState> = {
  actions,
  getters,
  mutations,
  state
}
export default mapLayerModule
